<template>
  <el-dialog
    title="账号变更"
    :visible.sync="loginnoVisible"
    width="30%"
    :before-close="closeLoginNo"
  >
    <el-form :model="loginno"  label-width="100px" :rules="rules" ref="loginno">
      <el-form-item label="原账号">
        <el-input v-model="loginno.originLoginno" disabled></el-input>
      </el-form-item>
      <el-form-item label="新账号" prop="changeLoginno">
        <el-input v-model="loginno.changeLoginno" placeholder="请输入新账号"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeLoginNo">取 消</el-button>
      <el-button type="primary" @click="updateLoginNo">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'loginno_select',
  data(){
    return {
      loginno:{
        originLoginno: '', // 原账号
        changeLoginno: '', // 新账号
      },
      rules:{
        changeLoginno:[{ required: true, message: '请输入新账号名称', trigger: 'blur' },{ pattern: /^\d{11}$/,message:"请输入正确的手机号码"  }]
        // changeLoginno:[{ validator: phoneLength, trigger: 'blur' },]
      }
    }
  },
  methods:{
    closeLoginNo(){
      this.$emit('closeLoginNo')
    },
    updateLoginNo(){
      console.log(123)
      console.log(this.$refs['loginno'])
      this.$refs['loginno'].validate(async (valid) => {
        console.log(valid)
        if (valid) {
          let response = await this.$api.changeLoginno(this.loginno)
          if(response.data.errcode == 0){
            this.$message.success('账号变更成功')
            this.$emit('updateLoginNo', this.loginno.changeLoginno)
            this.$emit('closeLoginNo')
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
  mounted(){
    this.loginno.originLoginno = this.oldLoginNo
  },
  props: {
    loginnoVisible:Boolean,
    oldLoginNo:String
  },
}
</script>
<style lang='less' scoped>
</style>